import "babel-polyfill"
import 'cropperjs/dist/cropper.min.css'

import Vue from "vue"
import store from "@/store/index"
import router from "./router"
import App from "./App"

import d2Admin from "@/plugin/d2admin"
Vue.use(d2Admin, { store })

import VueCoreVideoPlayer from 'vue-core-video-player'
Vue.use(VueCoreVideoPlayer, {
  lang: 'zh-CN'
})

new Vue({
  router,
  store,
  render: h => h(App),
  mounted() {
    //加载用户设置
    this.$store.dispatch("d2admin/account/load")
    //记录用户UA
    this.$store.commit("d2admin/ua/get")
    //全屏监听
    this.$store.dispatch("d2admin/fullscreen/listen")
  },
  watch: {
    //路由变化
    "$route.matched"(val) {
      //完整侧边栏
      const fullAside = this.$store.state.d2admin.menu.fullAside
      //当前侧边栏
      const _side = fullAside.filter(menu => menu.path === val[0].path)
      this.$store.commit("d2admin/menu/asideSet", _side.length > 0 ? _side[0].children : [])
    }
  }
}).$mount("#app")
